import React, { Component } from 'react';
import ReactDOM from 'react-dom';

import theme from 'shared/components/Select/elements/Menu/Menu.scss';

export default function withPortal(BaseComponent) {
  return class extends Component {
    constructor(props) {
      super(props);

      this.menuContainer = document.createElement('div');
    }
    componentDidMount() {
      this.rootPage = document.getElementById('rootPage');
      this.rootPage.appendChild(this.menuContainer);
    }

    componentWillUnmount() {
      this.rootPage.removeChild(this.menuContainer);
    }

    render() {
      return ReactDOM.createPortal(
        <div className={ theme.menuContainer }>
          <BaseComponent { ...this.props } />
        </div>
      , this.menuContainer);
    }
  };
}
